if (!customElements.get("card-product-slider")) {
  class CardProductSlider extends HTMLElement {
    constructor() {
      super();
      const options = JSON.parse(this.getAttribute("data-swiper-options")) || {};
      this.slider = null;
      this.sliderWrapper = this.querySelector(".swiper-wrapper");
      this.requiresFetch = this.hasAttribute("data-url");
      this.parent = this.closest("[data-section-id]");
      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        spaceBetween: options.spaceBetweenMobile || 2,
        slidesPerView: "auto",
        resistanceRatio: 0.72,
        navigation: {
          nextEl: ".swiper-button--next",
          prevEl: ".swiper-button--prev"
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: options.spaceBetweenDesktop || 2
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: options.spaceBetweenDesktop || 2
          }
        }
      };
    }

    connectedCallback() {
      if (this.requiresFetch) {
        this.fetchItems();
        return;
      }
      this.initSlider();
    }

    fetchItems() {
      if (!this.parent) {
        throw new Error("Parent is missing");
      }
      fetch(this.getAttribute("data-url"))
        .then((response) => response.text())
        .then((markup) => {
          const wrapper = new DOMParser().parseFromString(markup, "text/html").querySelector(".swiper-wrapper");
          if (!wrapper || !wrapper.innerHTML.trim().length) {
            return;
          }
          this.querySelector(".swiper-wrapper").innerHTML = wrapper.innerHTML;
          this.parent.classList.remove("hidden");
          this.initSlider();
        })
        .catch((error) => {
          console.error(error);
        });
    }

    initSlider(target = this) {
      if (this.slider) {
        return;
      }
      const mount = () => {
        if (this.slider) {
          return;
        }
        this.slider = new Swiper(target, this.sliderOptions);
        if (this.classList.contains("shop-the-look__inner")) {
          return;
        }
        this.decorateSlider();
      };
      const loader = window.themeLibraryLoader;
      if (loader && typeof loader.whenSwiperReady === "function") {
        loader.whenSwiperReady(mount);
      } else if (window.Swiper) {
        mount();
      }
    }

    decorateSlider() {
      if (!this.slider) {
        return;
      }
      const wrapper = this.slider.wrapperEl;
      wrapper.setAttribute("aria-live", "polite");
      wrapper.id = `swiper-wrapper-${this.dataset.sectionId}`;
      this.slider.slides.forEach((slide, index) => {
        slide.setAttribute("role", "group");
        slide.setAttribute("aria-label", `${index + 1} / ${this.slider.slides.length}`);
        slide.dataset.index = index;
      });
      [this.slider.navigation.prevEl, this.slider.navigation.nextEl].forEach((button, index) => {
        const label = index === 1 ? "Next" : "Previous";
        button.setAttribute("aria-label", `${label} slide`);
        button.setAttribute("aria-controls", wrapper.id);
      });
      wrapper.addEventListener("focusin", (event) => {
        if (event.target.closest("button, a, input, textarea, select")) {
          return;
        }
        this.slider.el.scrollLeft = 0;
        const slide = event.target.closest(".swiper-slide");
        if (!slide) {
          return;
        }
        const slideIndex = Number(slide.dataset.index);
        const isFirst = slideIndex === 0;
        const isLast = slideIndex === this.slider.slides.length - 1;
        if (isFirst || isLast) {
          this.slider.slideTo(slideIndex, 0);
          return;
        }
        const rect = slide.getBoundingClientRect();
        const wrapperWidth = this.slider.wrapperEl.clientWidth;
        const viewportOffset = rect.x + rect.width - (document.body.clientWidth - wrapperWidth) / 2;
        if (viewportOffset <= wrapperWidth && viewportOffset >= rect.width) {
          return;
        }
        if (viewportOffset >= rect.width) {
          this.slider.slideNext(0);
        } else {
          this.slider.slidePrev(0);
        }
      });
    }
  }

  customElements.define("card-product-slider", CardProductSlider);
}

document.addEventListener("shopify:section:load", (event) => {
  const slider = event.target.querySelector("card-product-slider");
  if (slider) {
    slider.connectedCallback();
  }
});
